import axios from 'axios'
import router from '@/router'


// 创建axios实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '',
  timeout: process.env.VUE_APP_API_TIMEOUT || 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})
// 打印api的baseURL
console.log('api的baseURL', api.defaults.baseURL)

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 自动添加token到请求头
    const token = localStorage.getItem('userToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers.Token = `${token}`
      // 或者根据后端要求使用其他格式
      // config.headers.token = token
    }
    
    // 检查是否为特殊IP用户，如果是则添加IP登录参数
    try {
      const ipInfoStr = localStorage.getItem('user_ip_info')
      if (ipInfoStr) {
        const ipInfo = JSON.parse(ipInfoStr)
        
        // 当code=1时表示特殊用户，需要添加IP登录参数
        if (ipInfo.code === 1 && ipInfo.data) {
          const ipLoginParams = {
            login_type: ipInfo.data.login_type || 'ip',
            login_id: ipInfo.data.login_id || ipInfo.data.id
          }
          
          // 所有请求都添加到URL参数（params）
          config.params = {
            ...config.params,
            ...ipLoginParams
          }
          
          console.log('🔐 特殊IP用户请求，已添加参数:', ipLoginParams)
        }
      }
    } catch (error) {
      console.error('处理IP登录参数失败:', error)
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    const { data } = response
    
    // 检查接口返回的code
    // IP检测接口：code=1(特殊用户) 或 code=2(普通用户) 都是成功
    // 其他接口：通常 code=1 表示成功
    if (data.code === 1 || data.code === 2) {
      return data
    } else {
      // API业务错误处理
      const errorMsg = data.msg || '请求失败'
      console.error('API Error:', errorMsg, 'Code:', data.code)
      return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    // 网络错误或其他错误处理
    let errorMsg = '网络错误，请检查网络连接'
    
    if (error.response) {
      // 服务器响应了错误状态码
      const status = error.response.status
      const data = error.response.data
      
      switch (status) {
        case 400:
          errorMsg = '请求参数错误'
          break
        case 401:
          // Token过期或无效，清除本地存储并跳转到登录页
          errorMsg = '登录已过期，请重新登录'
          localStorage.removeItem('userToken')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('userId')
          
          // 如果在浏览器环境中，跳转到登录页
          if (typeof window !== 'undefined') {
            // 使用router实例跳转到登录页
            router.push('/login').catch(err => {
              // 捕获导航重复等错误
              if (err.name !== 'NavigationDuplicated') {
                console.error('路由跳转错误:', err)
              }
            })
          }
          break
        case 403:
          errorMsg = '禁止访问'
          break
        case 404:
          errorMsg = '请求的资源不存在'
          break
        case 500:
          errorMsg = '服务器内部错误'
          break
        default:
          errorMsg = `服务器错误 (${status})`
      }
      
      // 如果API返回了具体的错误信息，优先使用
      if (data && data.msg) {
        errorMsg = data.msg
      }
    } else if (error.request) {
      // 请求发出但没有收到响应
      errorMsg = '网络连接超时，请重试'
    }
    
    console.error('Network Error:', error.message)
    return Promise.reject(new Error(errorMsg))
  }
)

// API接口定义
export const apiService = {
  // 获取banner配置
  getBanner() {
    return api.get('/index/getconfig', {
      params: {
        field: 'banner'
      }
    })
  },
  
  // 获取首页数据
  getHomePage() {
    return api.get('/index/home_page')
  },
  
  // 获取其他配置（可扩展）
  getConfig(field) {
    return api.get('/index/getconfig', {
      params: {
        field
      }
    })
  },
  
  // 获取配置列表（包含备案号、联系方式等信息）
  getConfigList() {
    return api.get('/index/getconfig_list')
  },
  
  // 获取类别配置图片
  getCategoryImage() {
    return api.get('/index/getconfig', {
      params: {
        field: 'leibie'
      }
    })
  },
  
  // 获取朝代分类数据
  getDynastyCategories() {
    return api.get('/index/getCategory', {
      params: {
        type: 2
      }
    })
  },
  
  // 获取题材分类数据
  getThemeCategories() {
    return api.get('/index/getCategory', {
      params: {
        type: 1
      }
    })
  },
  
  // 获取产品列表（支持筛选和分页）
  getProductList(params = {}) {
    return api.get('/index/index', {
      params: {
        page: params.page || 1,
        subcategories: params.subcategories || '',
        category: params.category || '',
        theme: params.theme || '',
        ...params
      }
    })
  },
  
  // 获取关于页面内容
  getAboutContent() {
    return api.get('/index/getconfig', {
      params: {
        field: 'about_content'
      }
    })
  },
  
  // 获取资讯背景图
  getNewsImage() {
    return api.get('/index/getconfig', {
      params: {
        field: 'zixun'
      }
    })
  },
  
  // 获取资讯列表
  getNewsList(params = {}) {
    return api.get('/Arch/getList', {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 10,
        ...params
      }
    })
  },
  
  // 获取资讯详情
  getNewsDetail(id) {
    return api.get('/Arch/getInfo', {
      params: {
        id: id
      }
    })
  },
  
  // 发送短信验证码
  sendSmsCode(mobile, event = 'mobilelogin') {
    return api.post('/sms/send', {
      mobile: mobile,
      event: event
    })
  },
  
  // 手机号登录
  mobileLogin(mobile, captcha) {
    return api.post('/user/mobilelogin', {
      mobile: mobile,
      captcha: captcha
    })
  },
  
  // 密码登录
  passwordLogin(account, password) {
    return api.post('/user/login', {
      account: account,
      password: password
    })
  },
  
  // 获取用户信息
  getUserInfo() {
    return api.get('/user/user_info')
  },
  
  // 上传头像
  uploadAvatar(file) {
    const formData = new FormData()
    formData.append('file', file)
    
    return api.post('/user/upload_ava', formData, {
      headers: {
        'Content-Type': 'multipart/fo m-data'
      }
    })
  },
  
  // 更新个人资料
  updateProfile(profileData) {
    return api.post('/user/profile', {
      bio: profileData.motto || profileData.bio,
      username: profileData.username
    })
  },
  
  // 获取下载记录列表
  getDownloadList(page = 1) {
    return api.get('/down/downList', {
      params: {
        page: page
      }
    })
  },
  
  // 换绑手机号
  changeMobile(mobile, captcha) {
    return api.post('/user/changemobile', {
      mobile: mobile,
      captcha: captcha
    })
  },
  
  // 修改密码
  resetPassword(newpassword) {
    return api.post('/user/resetpwd', {
      newpassword: newpassword
    })
  },
  
  // 获取收藏列表
  getCollectionList(page = 1) {
    return api.get('/user/collectlist', {
      params: {
        page: page
      }
    })
  },
  
  // 获取产品详情
  getProductDetail(id) {
    return api.get('/index/detail', {
      params: {
        id: id
      }
    })
  },
  
  // 获取DZI深度缩放图像链接
  getDziUrl(id) {
    return api.get('/index/getDzi', {
      params: {
        id: id
      }
    })
  },
  
  // 添加/取消收藏（统一接口）
  toggleCollection(resourceId) {
    return api.get('/index/collect', {
      params: {
        id: resourceId
      }
    })
  },
  
  // 添加收藏（向后兼容）
  addCollection(resourceId) {
    return this.toggleCollection(resourceId)
  },
  
  // 取消收藏（向后兼容）
  removeCollection(resourceId) {
    return this.toggleCollection(resourceId)
  },
  
  // 检查收藏状态
  checkCollectionStatus(resourceId) {
    return api.get('/index/collect_status', {
      params: {
        id: resourceId
      }
    })
  },
  
  // 获取下载链接
  getDownloadUrl(resourceId) {
    return api.get('/down/downResource', {
      params: {
        resource_id: resourceId
      }
    })
  },
  
  // 特殊IP用户获取下载链接
  getDownloadUrlForSpecialUser(resourceId) {
    // 从缓存中获取IP信息
    const ipInfoStr = localStorage.getItem('user_ip_info')
    let userId = null
    
    if (ipInfoStr) {
      try {
        const ipInfo = JSON.parse(ipInfoStr)
        if (ipInfo.data && ipInfo.data.id) {
          userId = ipInfo.data.id
        }
      } catch (error) {
        console.error('解析IP信息失败:', error)
      }
    }
    
    return api.get('/down/downResource_ip', {
      params: {
        resource_id: resourceId,
        id: userId // 添加IP用户的ID
      }
    })
  },
  
  // 记录下载
  recordDownload(resourceId) {
    // 从缓存中获取IP信息
    const ipInfoStr = localStorage.getItem('user_ip_info')
    let userId = null
    
    if (ipInfoStr) {
      try {
        const ipInfo = JSON.parse(ipInfoStr)
        if (ipInfo.isSpecialUser) {
          return Promise.resolve(true)
        }
      } catch (error) {
        console.error('解析IP信息失败:', error)
      }
    }
    
    return api.post('/user/download', {
      resource_id: resourceId
    })
  },
  
  // 微信登录
  wechatLogin(code) {
    return api.post('/user/third', {
      code: code
    })
  },
  
  // 获取充值套餐列表
  getRechargePackages() {
    return api.get('/meal/mealList')
  },
  
  // 创建支付订单
  createPayment(paymentData) {
    return api.post('/payment/create', {
      package_id: paymentData.package_id,
      amount: paymentData.amount,
      payment_method: paymentData.payment_method
    })
  },
  
  // 提交订单（微信支付）
  submitOrder(mealId, paymentType = 1) {
    return api.get('/meal/submitOrder', {
      params: {
        meal_id: mealId,
        payment_type: paymentType
      }
    })
  },
  
  // 查询支付状态
  getPaymentStatus(orderId) {
    return api.get('/payment/status', {
      params: {
        order_id: orderId
      }
    })
  },
  
  // 获取充值记录
  getRechargeHistory(page = 1) {
    return api.get('/payment/history', {
      params: {
        page: page
      }
    })
  },
  
  // IP登录检测
  checkIpLogin() {
    return api.get('/index/ip_login')
  }
}

export default api
